import { hideLightbox, showLightbox } from './lightbox';
import { FACEBOOK_ID__MEERKATS_STAGING, FACEBOOK_ID__MEERKATS_DEV, FACEBOOK_ID__IGNIA_DEV, FACEBOOK_ID__PEET } from '../constants';

const scope = 'email';
const endpoints = {
  login: '/LoginRegister/FacebookLogin',
  register: '/LoginRegister/FacebookRegister'
};
const sendData = (action, data, success, error) => {

  $.ajax({
    url: endpoints[action],
    type: 'POST',
    data: JSON.stringify(data),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success,
    error
  });
};

let FB;
const PEET = {
    login: (email, autologin) => {

        const success = ({ saved_products: saved }) => {
        
      if (typeof saved === 'undefined') {
        $('.form__description--facebook-login-error').css('display', 'block');
      }
      else {
        $(`<div class="user-menu__saved">${saved}</div>`).prependTo('.user-menu');
        !autologin && showLightbox('You are now logged in', 'loggedin');
      }
    };

        const error = ({ reason }) => {
      console.log(`Login error: ${reason}`); // eslint-disable-line no-console
    };

    sendData('login', { emailAddress: email }, success, error);
  },
  register: (userData) => {
    const success = () => {
      $('<div class="user-menu__saved">0</div>').prependTo('.user-menu');
      showLightbox('Thank you for registering', 'loggedin');
    };

    const error = ({ reason }) => {
      console.log(`Login error: ${reason}`); // eslint-disable-line no-console
    };

    sendData('register', userData, success, error);
  }
};

const handleLoginResponse = ({ status }, autologin) => {
   
  if (status === 'connected') { 
      FB.api('/me', { fields: 'email' }, ({ email }) => {
 
      if (email) {
        //hideLightbox();
        PEET.login(email, autologin);
      }
      else {
        FB.login(handleLoginResponse, { scope, auth_type: 'rerequest' });
      }
    });
  }
};

const handleRegistrationResponse = ({ status }) => {
  if (status === 'connected') {
      FB.api('/me', { fields: 'email, id, cover, name, first_name, last_name, locale, picture, timezone, updated_time, verified' }, (response) => {
    
      const { email, first_name: firstName, last_name: lastName } = response;
      if (email) {
        hideLightbox();
        const phoneNumber = (/.+@.+\..+/).test(email) ? null : email;
        const registrationData = {
          emailAddress: phoneNumber ? `NoFacebookEmail${(new Date()).getTime()}@peet.com.au` : email,
          firstName,
          lastName,
          phoneNumber,
          suburb: 'Facebook',
          facebookData: response
        };
        PEET.register(registrationData);
      }
      else {
        FB.login(handleLoginResponse, { scope, auth_type: 'rerequest' });
      }
    });
  }
};

const getFacebookId = () => {
  switch (window.location.hostname) {
    case 'peet.staging.meerkats.com.au':
      return FACEBOOK_ID__MEERKATS_STAGING;
    case 'peet.dev.local':
      return FACEBOOK_ID__IGNIA_DEV;
    case 'localhost':
      return FACEBOOK_ID__MEERKATS_DEV;
    default:
      return FACEBOOK_ID__PEET;
  }
};

export const initialize = () => {
  if (!document.getElementById('fb-root')) {
    const fbRoot = document.createElement('div');
    fbRoot.setAttribute('id', 'fb-root');
    document.body.insertBefore(fbRoot, document.body.firstChild);
  }

  window.fbAsyncInit = () => {
    FB = window.FB;
    FB.init({
      appId: getFacebookId(),
      cookie: true,
      xfbml: true,
      version: 'v2.8'
    });
  };

  // Load the SDK asynchronously
  ((d, s, id) => {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    const js = d.createElement(s); js.id = id;
    js.src = '//connect.facebook.net/en_US/all.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
};

export const activateLoginButtons = () => {
  Array.from(document.querySelectorAll('.facebook-login-button')).forEach((button) => {
    const $button = $(button);
    const buttonHandler = $button.data('action') === 'login' ? handleLoginResponse : handleRegistrationResponse;
    $button.on('click', (e) => {
      e.preventDefault();
      FB.login(buttonHandler, { scope });
    });
  });
};
